import {
  Button,
  Box,
  GridItem,
  Heading,
  Text,
  Flex,
  HStack,
  Center, useStyleConfig,
} from '@chakra-ui/react';
import {
  getImg,
  handleChange,
  handleUnfocus,
  getFocus,
  handleFocus,
} from './utils';
import { handleSubmit } from '../../components/ProgressiveFormStepper/utils';

function RadioCard({ props, qObj, template, inputProps, index, styles }) {
  const focus = getFocus(props, template, inputProps.value);
  const variant="wrapper";
  const buttonStyles = useStyleConfig('Button', { variant });
  const googleImg = props.stateProps.imgDomain + '/google-docs.png';
  const wordImg = props.stateProps.imgDomain + '/word.png';

  return (
    <GridItem rowSpan={1} colSpan={1} as="label">
      <input {...inputProps} />
      <Box
        onMouseEnter={() => handleFocus(props.stateProps, template)}
        onMouseLeave={() => handleUnfocus(props.stateProps, template)}
        onClick={() => handleFocus(props.stateProps, template)}
        sx={{ ...styles.radioCard }}
      >
        <Box zIndex={focus} sx={{ ...styles.templateImage }}>
          <img
            src={getImg(props.stateProps.imgDomain, template.label)}
            alt={template.label}
          />
        </Box>
        <Box sx={{ ...styles.focusOverlay }} />
        <Flex
          flexDirection="column"
          sx={{
            gridArea: 'box',
            placeSelf: 'center',
            height: 'full',
            width: 'full',
            zIndex: '1',
            padding: ['12px', '36px', '24px', null, '36px'],
          }}
        >
          <GridItem
            display="flex"
            flexGrow={2}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width="100%"
          >
            <Heading
              sx={{
                textAlign: 'center',
                fontSize: ['20px', '26px'],
                fontWeight: 700,
                textTransform: ['uppercase', null, 'none'],
                padding: '0 0 8px',
                margin: '0',
              }}
            >
              {template.label}
            </Heading>
            <Text
              sx={{
                fontSize: '16px',
                textAlign: 'center',
                maxWidth: '350px',
              }}
            >
              {template.description}
            </Text>
          </GridItem>
          <GridItem
            display="flex"
            flexGrow={1}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            // width="100%"
          >
            <Button
              variant="primary"
              sx={{ ...buttonStyles.primary}}
              onClick={() => {
                handleChange(
                  props.stateProps,
                  props.formikProps,
                  inputProps.value,
                  index,
                  qObj,
                );
                handleSubmit(props);
              }}
            >
              Select
            </Button>
          </GridItem>
        </Flex>
      </Box>
      <Heading
        sx={{
          textAlign: 'center',
          fontSize: ['20px', '26px'],
          fontWeight: 700,
          textTransform: ['uppercase', null, 'none'],
          padding: 0,
          margin: '8px 0 0',
        }}
      >
        {template.label}
      </Heading>
      <Text
        variant="o16"
        sx={{
          textAlign: 'center',
        }}
      >
        compatible with
      </Text>
      <Center sx={{ paddingBottom: '12px' }}>
        {template.format === 'word' && (
          <img width="32px" alt="Word Document" height="32px" src={wordImg} />
        )}
        {template.format !== 'word' && (
          <HStack>
            <img width="32px" alt="Word/Google Document" height="32px" src={googleImg} />
            <img width="32px" alt="Word Document" height="32px" src={wordImg} />
          </HStack>
        )}
      </Center>
    </GridItem>
  );
}

export default RadioCard;
